/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from 'react';
import { Box, Flex, Spinner, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

const M_ASSIGN = gql`
	mutation assign($statementId: String!, $assigneeId: String!, $notification: Boolean = false) {
		assignEarlyWarningStatementToAssigneeId(statementId: $statementId, assigneeId: $assigneeId, notification: $notification)
	}
`;

function TransferEwsItem({ statementId = null, assigneeId = null, notification = false, onNext = () => null }) {
	const { t } = useTranslation();
	const [status, setStatus] = useState(null);
	const [error, setError] = useState(null);
	const [assignUser, { loading }] = useMutation(M_ASSIGN);

	useEffect(() => statementId && assigneeId && submit(), [statementId, assigneeId, notification]);

	function submit() {
		assignUser({ variables: { statementId, assigneeId, notification } })
			.then(({ data }) => {
				setStatus(data?.assignEarlyWarningStatementToAssigneeId);
				setError(null);
				setTimeout(onNext, 50);
			})
			.catch((error) => {
				setError(error);
				setStatus(null);
				setTimeout(onNext, 50);
			});
	}

	return (
		<Flex justifyContent="flex-start" alignItems="center">
			{loading && (
				<>
					<Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="sm" />
				</>
			)}
			{!loading && status === 'success' && (
				<Tooltip label={t('Success')}>
					<Box>
						<FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 14, color: '#2ecc71' }} />
					</Box>
				</Tooltip>
			)}
			{!loading && status === 'duplicated' && (
				<Tooltip label={t('Duplicated')}>
					<Box>
						<FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 14, color: '#eab308' }} />
					</Box>
				</Tooltip>
			)}
			{!loading && error && (
				<Tooltip label={t('Click to retry')}>
					<Box>
						<FontAwesomeIcon
							icon={faRedoAlt}
							style={{ fontSize: 14, color: '#dc2626' }}
							onMouseDown={() => {
								assignUser({ variables: { statementId, assigneeId, notification } })
									.then(({ data }) => {
										setStatus(data?.assignEarlyWarningStatementToAssigneeId);
										setError(null);
									})
									.catch((error) => {
										setError(error);
										setStatus(null);
									});
							}}
						/>
					</Box>
				</Tooltip>
			)}
		</Flex>
	);
}

export default memo(TransferEwsItem);
